import { useEffect } from 'react';

import { SocialActionEnum } from '../../hooks/ControllerSocialMedia';

import { initFB } from '../../services/socialNetWorkController';
import Icon from '../Icon/Icon';
import './SocialMedia.scss';
import {
  handleOAuthRedirectURI,
  saveSocialFlowPath
} from '../../utils/GenericFunctions';
import { setCookie } from '../../services/cookieController';
import { useAuthContext } from '../../hooks/AuthContext';
import Button from '../Button/Button';

interface ButtonFaceProps {
  action?: SocialActionEnum;
  showText?: boolean;
}

export default function ButtonFace({
  action,
  showText = false
}: ButtonFaceProps) {
  const { redirectURL } = useAuthContext();

  useEffect(() => {
    initFB();
  }, []);

  return (
    <Button
      customColors="btn-neutral"
      id="facebook-btn"
      data-testid="btn-face"
      aria-label="Entrar com Facebook"
      onClick={() => {
        if (redirectURL) setCookie('redirect', redirectURL);
        saveSocialFlowPath();
        window.open(
          `https://www.facebook.com/v17.0/dialog/oauth?client_id=${
            process.env.REACT_APP_APPID_FACE
          }&redirect_uri=${handleOAuthRedirectURI(
            'facebook',
            action
          )}&scope=email,public_profile,user_birthday&return_scopes=true&fields=name,email&response_type=token&state=421421`,
          '_self'
        );
      }}
    >
      <Icon name="logoFace" />
      {showText && 'Continuar com Facebook'}
    </Button>
  );
}
